import axios, { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Address } from '@/types/address'

interface Folder {
  id: number
  name: string
  description: string
  updatedAt: string
  ownerId: number
  address: Address
}

export type ByWhom = 'byownerid' | 'byuserid'

export type GetFoldersResponse = Folder[]

export async function getFolders(
  id: number,
  byWhom: ByWhom,
  options?: AxiosRequestConfig,
) {
  try {
    const { data } = await companiesApi.get<GetFoldersResponse>(
      `${apiRoutes.getFolders}/${byWhom}`,
      {
        params: {
          id,
        },
        ...options,
      },
    )

    return data
  } catch (error) {
    const isNotFound =
      axios.isAxiosError(error) && error.response?.status === 404

    if (isNotFound || axios.isCancel(error)) return []

    throw error
  }
}
